export function getAppMarket(): string {
    const launchEnv = (window as any).launchEnv;

    if (launchEnv === "telegram") {
        return import.meta.env.VITE_TELEGRAM_MARKET_NAME || "telegram";
    }

    return import.meta.env.VITE_MARKET_NAME || "web";
}
